<div class="buy-now derecha">
    <a href="{{href}}" target="_blank" class="ayuda-link">
        <span class="ayuda-texto">Necesito ayuda</span>
        <img src="assets/images/iconos-flotantes/whatsapp.png" width="50" alt="WhatsApp">
    </a>
</div>
